import styled from 'styled-components';

import { Text, Link } from 'components';

import { DRAWER_PADDING, DRAWER_WIDTH } from '../../constants';

export const Container = styled.div`
  max-width: ${DRAWER_WIDTH}px;
`;

export const StyledContent = styled.div`
  overflow-y: auto;
`;

export const HeaderContainer = styled.div`
  margin-bottom: -12px;
  padding: 0px ${DRAWER_PADDING}px;
`;

export const HeaderText = styled(Text)`
  font-weight: 600;
`;

export const ContentContainer = styled.div`
  padding: 0px ${DRAWER_PADDING}px;
`;

export const ListContainer = styled.div`
  padding-top: 20px;
`;

export const ListingContainer = styled.div`
  padding: 0px ${DRAWER_PADDING / 2}px;
  cursor: pointer;
`;

export const DetailsContainer = styled.div`
  max-width: ${DRAWER_WIDTH}px;
`;

export const Section = styled.div``;

export const TouchableValue = styled(Link)`
  flex: 1;
  word-break: break-all;
`;

export const Value = styled(Text)`
  flex: 1;
  word-break: break-word;
`;
